export enum ThirdPartyId {
	Clio = "8416B464-FBD7-4D08-9D15-48FBA89E641B",
	AmazonBedrockClaude = "E41976C6-9E7F-4F6E-B3AF-602408403DAE",
	OpenAi = "CF895275-6259-49D3-AF61-D8C3E65AAA7E"
}
